import moment from "moment";
import { toast } from "react-toastify";

const toastList = new Set();
const MAX_TOAST = 2;
export const API_TIME_OUT = 200;

export const notify = (test, message) => {
  if (toastList.size < MAX_TOAST) {
    let id;
    if (message === "success") {
      id = toast.success(test, {
        autoClose: 1500,
        onClose: () => toastList.delete(id),
      });
    } else {
      id = toast.error(test, {
        autoClose: 1500,
        onClose: () => toastList.delete(id),
      });
    }
    toastList.add(id);
  }
};

export const notifyAPIMessages = (res) => {
  if (res) {
    if (res?.status === 200 || res?.status === 201) {
      notify(res?.data?.message || res?.data, "success");
    } else {
      const newMessage =
        res?.response?.data?.message || res?.response?.data || res?.message;
      newMessage && notify(newMessage);
    }
  }
};

const moment2 = require("moment-timezone");
export const defaultTimeZone = moment2.tz.guess();

export const DateUtility = {
  dashDate: (date) => moment(date).format("MM-DD-YYYY"),
  dashDate1: (date) =>
    moment.utc(date).clone().tz(defaultTimeZone).format("MM-DD-YYYY"),
  fullMDayYear: (date) => moment(date).format("MMMM DD, YYYY"),
  dateNTime: (date) => moment(date).format("hh:mm A, DD MMM YYYY"),
  ancDuration: (date) => moment(date).format("DD MMM YY"),
  todayDay: (date) => moment(date).weekday(),
  todayDate: (date) => moment(date).format("DD"),
  month: (date) => moment(date || new Date()).format("MMM"),
  monthYear: (date) => moment(date).format("MMM YYYY"),
  date24time: (date) => moment(date).format("ddd, MMM D, YYYY. h:mm"),
  AmPmTime: (date) => moment(date, "h:mm:ss A").format("LT"),
  nameDayMonthYear: (date) => moment(date).format("DD MMM YYYY"),
  dayMonthYearTime: (date) => moment(date).format("DD MMMM YYYY, hh:mm A"),
  monthDateYearTime: (date) => moment(date).format("MMMM DD, YYYY, HH:mm"),
  dayMonthYearTimeWithDash: (date) =>
    date ? moment(date).format("DD-MM-YYYY, hh:mm A") : " - ",
  dayMonthYearTimeWithSlash: (date) =>
    date ? moment(date).format("DD/MM/YYYY, hh:mm A") : " - ",
  AmPmTimeWithoutSecond: (date) => moment(date).format("hh:mm A"),
  nameDayMonthYearTime: (date) =>
    moment(date).format("ddd, DD MMM YYYY, hh:mm A"),
  dayMonthYear: (date) => moment(date).format("DD MMM YYYY"),
  requestDateTime: (date) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
  dayMonth: (date) => moment(date).format("DD MMM"),
  fullDateTime: (date) => moment(date).format("MMMM DD, YYYY, hh:mm A"),
  requestTime: (date) => moment(date).format("HH:mm:ss"),
  orderTime: (date) => moment(date).format("DD MMM, hh:mm A"),
  dayMonthYear2: (date) => moment(date).format("DD/MM/YYYY"),
  monthDayYear: (date) => moment(date).format("MM/DD/YYYY"),
};

export const nameFormatting = (user, type) => {
  if (type === "FL") {
    return user && user?.firstname?.trim().concat(", ", user?.lastname?.trim());
  } else if (type === "FLC") {
    return user && user?.firstname?.trim().concat(" ", user?.lastname?.trim());
  } else if (type === "LF") {
    return user && user?.lastname?.trim().concat(" ", user?.firstname?.trim());
  } else {
    return user && user?.lastname?.trim().concat(", ", user?.firstname?.trim());
  }
};
